import React, { useMemo, useCallback } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { TranslatorContext, IntlContext } from "@jutro/locale";
import { ViewModelForm } from "gw-portals-viewmodel-react";
import {
    UmbrellaCoverageTable,
    UmbrellaUnderlyingPolicyTable,
} from "../UmbrellaCoverageTable/UmbrellaCoverageTable";

import metadata from "./UmbrellaCoverages.metadata.json5";

function UmbrellaCoverageInfo(props) {
    const { value: umbrellaCoverables } = props;
    const coverables = umbrellaCoverables.coverables;
    const underlyingPolicies = umbrellaCoverables.underlyingPolicies;

    const UmbrellaCoverages = useMemo(() => {
        return coverables.find((coverable) => {
            if (coverable.name === "Umbrella Line") {
                return coverable.coverages;
            }
        });
    }, [coverables]);

    const getLimitDeductibleValue = (terms, type) => {
        if (!_.isEmpty(terms)) {
            return terms.find((term) => term.modelType === type).amount;
        }
        return "-";
    };

    const getCoverage = useCallback(() => {
        return UmbrellaCoverages.coverages.map((coverage) => {
            return {
                name: coverage.name,
                limit: getLimitDeductibleValue(coverage.terms, "Limit"),
                deductible: getLimitDeductibleValue(coverage.terms, "Deductible"),
                premium: coverage.premium,
            };
        });
    }, []);

    const getUnderlyingPolicies = useCallback(() => {
        return underlyingPolicies.map((underlyingPolicy) => {
            return {
                policyType: underlyingPolicy.policyType,
                policyNumber: underlyingPolicy.policyNumber,
                liabilityLimit: underlyingPolicy.liabilityLimit,
            };
        });
    }, []);

    const overrides = {
        coverageInfo: {
            data: getCoverage(),
        },

        underlyingPolicyInfo: {
            data: getUnderlyingPolicies(),
        },
    };

    const resolvers = {
        resolveComponentMap: {
            umbrellacoverage: UmbrellaCoverageTable,
            underlyingPolicy: UmbrellaUnderlyingPolicyTable,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={UmbrellaCoverages}
            overrideProps={overrides}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
    UmbrellaCoverageInfo.propTypes = {
        value: PropTypes.shape({}),
    };
}
export default UmbrellaCoverageInfo;
